import { createRoute } from '@tanstack/react-router';

import { RootRoute } from '$/routes/RootRoute';

export const ImprintRoute = createRoute({
  getParentRoute: () => RootRoute,
  path: '/imprint',
}).lazy(() => import('./ImprintRoute.lazy').then((d) => d.LazyImprintRoute));
